export const REVIEW_DETAILS = {
    VEHICLE_DETAILS: 'VEHICLE_DETAILS',
    CUSTOMER_DETAILS: 'CUSTOMER_DETAILS',
    PLAN_DETAILS: 'PLAN_DETAILS',
};
